import { render, staticRenderFns } from "./financialInsurance.vue?vue&type=template&id=effe2c86&scoped=true"
import script from "./financialInsurance.vue?vue&type=script&lang=js"
export * from "./financialInsurance.vue?vue&type=script&lang=js"
import style0 from "./financialInsurance.vue?vue&type=style&index=0&id=effe2c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "effe2c86",
  null
  
)

export default component.exports